import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceAdvancedSearchService {
  baseUrl: string = environment.API_SERVER;
  toggleSearch = new EventEmitter();
  exportSearch = new EventEmitter();
  routes = {
    list: 'list',
    payment: 'payment',
    'non-invoiced-payment': 'non-invoiced-payment'
  }

  constructor(private _http: HttpClient) { }

  searchExport(payload): Observable<any> {
		const url = `${this.baseUrl}/finance/invoice/customer/invoices/export`;
		return this._http.get(url, {params: payload.params});
	}

  paymentExport(payload): Observable<any> {
		const url = `${this.baseUrl}/finance/${payload.invoiced}/payment/customer-payments/nullable/export`;
		return this._http.get(url, {params: payload.params});
	}

}
